import request from "@/request/confJs/request";
import { API_ENDPOINTS } from "@/config/api";
import { toStoredFileValue } from "@/utils/fileUrl";

const withStoredAvatar = (data) => ({
  nickName: data?.nickName,
  name: data?.name,
  password: data?.password,
  sex: data?.sex,
  telephone: data?.telephone,
  email: data?.email,
  profile: data?.profile,
  avtor: toStoredFileValue(data?.avtor),
});

export const registerApi = (data) =>
  request({
    url: API_ENDPOINTS.user.register,
    method: "POST",
    headers: { isToken: false },
    data: withStoredAvatar(data),
  });

export const loginApi = (data) =>
  request({ url: API_ENDPOINTS.user.login, method: "POST", headers: { isToken: false }, data });

export const updateUser = (data) =>
  request({ url: API_ENDPOINTS.user.update, method: "POST", data: withStoredAvatar(data) });

export const changePassword = (data) =>
  request({ url: API_ENDPOINTS.user.changePassword, method: "POST", data });

export const getAdminUsers = (params) =>
  request({ url: API_ENDPOINTS.user.adminUsers, method: "GET", params });

export const updateAdminUserAccess = (data) =>
  request({ url: API_ENDPOINTS.user.adminAccess, method: "POST", data });

export const resetAdminUserPassword = (data) =>
  request({ url: API_ENDPOINTS.user.adminResetPassword, method: "POST", data });
